import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { translate } from '../Services/translation';
import { registerLocale } from  "react-datepicker";
import * as lang from 'date-fns/locale/';

import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
 
class DatePickerContainer extends Component {
    constructor(props) {
        super(props);

        this.locale = document.getElementById("date-picker-container").dataset.locale;
        let twoLetterLocale = this.locale.slice(0, 2);

        if(lang[twoLetterLocale] != undefined) {
            registerLocale(twoLetterLocale, lang[twoLetterLocale]);
        } else {
            this.locale = "en";
        }

        let params = new URLSearchParams(window.location.search);
        this.state = {
            startDate: Date.parse(params.get(this.props.name))
          };
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        this.setState({
        startDate: date
        });
    };
 
    render() {
        return (
        <DatePicker
            autoComplete="off"
            locale={this.locale}
            className="date-background"
            placeholderText={translate(this.props.placeholder)}
            name={this.props.name}
            dateFormat="yyyy-MM-dd"
            selected={this.state.startDate}
            onChange={this.handleChange}
        />
        );
    }
}

export default DatePickerContainer;